import { Carousel } from './carousel';

export class PromoCarousel extends Carousel {
  /**
   * css selector of carousel container
   * @static
   */
  static selector = '.js-carousel';

  /**
   * Checks if container node is present in the dom
   * @function isOnPage
   * @returns {Boolean}
   * @static
   */
  static isOnPage() {
    return document.querySelector(PromoCarousel.selector);
  }

  constructor() {
    super();
    this.carousel = new Map();
    super.init(this, PromoCarousel.selector);
  }

  /**
   * Adds event listener for focus to activate the slide.
   * @param {Swiper} swiper - Swiper instance.
   * @param {Node} $carouselElement - DOM element of the carousel.
   */
  enableFocusSlideActivation(swiper, $carouselElement) {
    $carouselElement.addEventListener('focusin', (event) => {
      const slideElement = event.target.closest('.swiper-slide');

      if (slideElement && swiper && $carouselElement.contains(slideElement)) {
        const slideIndex = Array.from(swiper.slides).indexOf(slideElement);

        if (slideIndex > -1 && swiper.activeIndex !== slideIndex) {
          swiper.slideTo(slideIndex, 0);
        }
      }
    });
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @param {Node} $carousel - Carousel DOM Node
   * @returns {Object} extended config
   */
  generateConfig($carousel) {
    if (super.hasSingleSlide($carousel)) {
      return super.extendConfig({
        pagination: false,
        loop: false,
        autoplay: false,
        roundLengths: true
      });
    }

    // eslint-disable-next-line consistent-this
    const self = this;

    return super.extendConfig({
      autoplay: super.toggleAutoplay($carousel),
      watchSlidesVisibility: true,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      },
      pagination: {
        el: $carousel.querySelector('.js-carousel-pagination'),
        clickable: true,
        type: 'bullets',
        renderBullet: (index, className) => {
          const controlsNav = $carousel.querySelector('.carousel-controls');
          const baseLabel = controlsNav?.getAttribute('data-aria-label') || 'Slide';

          return `<button class="${className}" aria-current="false" data-index="${index + 1}" aria-label="${baseLabel} ${index + 1}"></button>`;
        }
      },
      roundLengths: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
      },
      on: {
        init: function (swiper) {
          const paginationElement = swiper.pagination?.el;
          const controlsNav = swiper.el?.querySelector('.carousel-controls');
          const baseLabel = controlsNav?.getAttribute('data-aria-label') || 'Slide';

          if (paginationElement) {
            // eslint-disable-next-line no-unused-expressions
            paginationElement.querySelector('.swiper-pagination-bullet-active')?.setAttribute('aria-current', 'true');

            paginationElement.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
              const bulletIndex = bullet.getAttribute('data-index') || (Array.from(bullet.parentNode.children).indexOf(bullet) + 1);

              if (!bullet.hasAttribute('aria-label') || bullet.getAttribute('aria-label') === '') {
                bullet.setAttribute('aria-label', `${baseLabel} ${bulletIndex}`);
              }
            });
          }

          self.enableFocusSlideActivation(swiper, $carousel);
        },

        slideChange: function (swiper) {
          const paginationElement = swiper.pagination?.el;

          if (paginationElement) {
            paginationElement.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
              bullet.setAttribute('aria-current', bullet.classList.contains('swiper-pagination-bullet-active') ? 'true' : 'false');
            });
          }
        }
      }
    });
  }
}